<template>
  <div
    style="width:100%; height:100%; display:flex; background:white"
    v-show="forms.AssetId !== undefined && forms.JenisAsset == 'jalan'"
  >
    <div style="width:300px; height:300px; background:silver;">
      <Map
        ref="map"
        :layers="[
          {
            name: 'lokasi',
            type: 'linestring',
            multipoint: forms.Lokasi,
            focus: true,
          },
        ]"
        width="300px"
        height="300px"
        :searchbox="false"
        :disabled="true"
      />
      <div style="border-bottom: 1px solid silver; display:flex">
        <v-btn text color="primary" @click="tab = 'detail'">
          DETAIL
        </v-btn>
      </div>
      <div
        style="border-bottom: 1px solid silver; display:flex"
        v-if="forms.AssetId"
      >
        <v-btn text color="primary" @click="tab = 'potensi'">
          POTENSI
        </v-btn>
        <v-spacer />
        <v-chip small color="silver" style="margin-top: 6px;">
          {{ jmlAktif }} / {{ jmlPotensi }}
        </v-chip>
      </div>
    </div>
    <div
      style="padding:10px; max-width:100vw;"
      :class="isMobile ? '' : 'form-inline'"
      :style="isMobile ? '' : 'width:calc(100vw - 650px)'"
    >
      <Input type="text" label="Nama Asset" :value.sync="forms.NamaAsset" />
      <div v-if="tab == 'detail'">
        <Select
          label="Balai"
          dbref="MST.SelBalai"
          width="500px"
          :value.sync="forms.BalaiId"
        />
        <Input
          type="number"
          label="Panjang Jalan"
          :value.sync="forms.Luas"
          postfix="meter"
        />
        <Label label="Ringkasan Potensi" v-if="forms.AssetId">
          <v-chip small color="success" style="border-radius: 20px 0 0 20px;">
            {{ hargaAktif | format }}
          </v-chip>
          <v-chip small color="silver" style="border-radius: 0 20px 20px 0;">
            {{ parseInt(hargaPotensi) | format }}
          </v-chip>
        </Label>
        <potensi-summary
          :params="forms"
          v-if="forms.AssetId"
          style="width:650px;"
          :style="isMobile ? '' : 'margin-left: 160px;'"
        ></potensi-summary>
        <br />
        <v-btn color="primary" @click="Save" write>SIMPAN</v-btn>
      </div>
      <div v-else-if="tab == 'potensi'">
        <Grid
          :datagrid.sync="datagrid"
          dbref="AST.PotensiList"
          :dbparams="potensiParams"
          :disabled="true"
          :width="isMobile ? '100%' : 'calc(100% - 30px)'"
          :height="isMobile ? 'calc(100vh - 230px)' : 'calc(100vh - 210px)'"
          :doRebind="rebindPotensi"
          :columns="[
            { name: 'Nama', value: 'NamaPotensi' },
            { name: 'Jenis', value: 'JenisPenerimaan' },
            { name: 'Status', value: 'StatusSewa' },
            { name: 'Harga', value: 'Harga', class: 'right' },
            { name: '', value: 'menu', width: '50px' },
          ]"
          @row-click="rowClick"
        >
          <template v-slot:row-NamaPotensi="{ row }">
            <v-icon
              v-if="row.Sebelah == 'kanan'"
              v-tooltip="'Sebelah Kanan'"
              @click="OpenStreetView(row)"
              color="info"
            >
              mdi-map-marker-right
            </v-icon>
            <v-icon
              v-else
              v-tooltip="'Sebelah Kiri'"
              @click="OpenStreetView(row)"
              color="info"
            >
              mdi-map-marker-left
            </v-icon>
            <span style="position:relative; left:8px; top:1px;">
              {{ row.NamaPotensi }}
            </span>
          </template>
          <template v-slot:row-JenisPenerimaan="{ row }">
            {{ row.JenisPenerimaan | fixcase }}
          </template>
          <template v-slot:row-StatusSewa="{ row }">
            <div v-if="row.StatusSewa == 'potensi'">
              {{ row.StatusSewa | fixcase }}
            </div>
            <v-btn
              v-else
              :color="statusColor[row.Status]"
              :outlined="statusOutline[row.Status]"
              x-small
              @click="StatusClick(row)"
            >
              {{ row.Status }}
            </v-btn>
          </template>
          <template v-slot:row-Harga="{ row }">
            {{ row.Harga | format }}
          </template>
          <template v-slot:row-menu="{ row }">
            <MenuButton
              :items="[
                { text: 'Ubah', icon: 'mdi-pencil-box' },
                { text: 'Penerimaan' },
                { text: 'Hapus', color: 'red' },
              ]"
              @click="PotensiClick($event, row)"
            >
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-dots-vertical</v-icon>
              </template>
            </MenuButton>
          </template>
        </Grid>
        <div style="display:flex">
          <v-btn color="primary" @click="AddPotensi" write>
            <v-icon left>mdi-plus</v-icon>
            TAMBAH POTENSI
          </v-btn>
          <Uploader @change="UploadKML" accept=".kml" write>
            <template v-slot="{ opener }">
              <v-btn
                outlined
                color="primary"
                style="margin-left:5px;"
                @click="opener"
              >
                <v-icon left>mdi-upload</v-icon>
                KML
              </v-btn>
            </template>
          </Uploader>
          <Uploader @change="UploadLedger" accept=".xlsx" write>
            <template v-slot="{ opener }">
              <v-btn
                outlined
                color="primary"
                style="margin-left:5px;"
                @click="opener"
              >
                <v-icon left>mdi-upload</v-icon>
                LEDGER
              </v-btn>
            </template>
          </Uploader>
        </div>
      </div>
    </div>
    <add-penerimaan
      :data.sync="potensi"
      @reload="rebindPotensi++"
    ></add-penerimaan>
    <upd-penerimaan :forms="potensi" @reload="rebindPotensi++"></upd-penerimaan>
  </div>
</template>
<script>
import Label from '../../../components/Forms/Label.vue'
import AddPenerimaan from '../Penerimaan/AddPenerimaan.vue'
import UpdPenerimaan from '../Penerimaan/UpdPenerimaan.vue'
import PotensiSummary from './PotensiSummary.vue'
export default {
  components: { AddPenerimaan, UpdPenerimaan, Label, PotensiSummary },
  data: () => ({
    tab: 'detail',
    potensi: { show: false, showUpd: false },
    rebindPotensi: 0,
    datagrid: null,
    summary: [],
    jmlAktif: 0,
    hargaAktif: 0,
    jmlPotensi: 0,
    hargaPotensi: 0,
    statusColor: {
      'Jatuh Tempo': 'error',
      'Hampir Tempo': 'warning',
      'Belum Bayar': 'warning',
      'Sudah Bayar': 'info',
    },
    statusOutline: {
      'Jatuh Tempo': false,
      'Hampir Tempo': false,
      'Belum Bayar': true,
      'Sudah Bayar': true,
    },
  }),
  props: {
    forms: Object,
  },
  watch: {
    'forms.AssetId'(val) {
      this.Populate(val)
    },
    datagrid(val) {
      this.$refs.map.removeLayer('marker-potensi')
      val.forEach(v => {
        if (v.Lokasi) {
          let x = v.Lokasi.replace(/[^\d.-\s]/g, '').split(' ')
          this.$refs.map.addMarker({
            lat: x[0],
            lon: x[1],
            title: v.NamaPotensi,
            layer: 'potensi',
          })
        }
      })
    },
  },
  computed: {
    potensiParams() {
      return { AssetId: this.forms.AssetId }
    },
    isMobile() {
      return document.body.clientWidth < document.body.clientHeight
    },
  },
  mounted() {
    this.$api.Authorize()
  },
  methods: {
    async Populate(id) {
      if (id) {
        this.forms.AssetId = id
        let d = await this.$api.call('AST.SelAsset', {
          AssetId: id,
        })
        if (d.data.length) {
          this.jmlAktif = d.data[0].JmlAktif || 0
          this.jmlPotensi = d.data[0].JmlPotensi || 0
          this.hargaAktif = d.data[0].HargaAktif || 0
          this.hargaPotensi = d.data[0].HargaPotensi || 0
        } else {
          this.jmlAktif = 0
          this.jmlPotensi = 0
          this.hargaAktif = 0
          this.hargaPotensi = 0
        }
      }
    },
    async UploadKML(file) {
      await this.$api.post('/api/asset/read-kml', {
        AssetId: this.forms.AssetId,
        File: file.data,
      })
      this.rebindPotensi++
    },
    async UploadLedger(file) {
      await this.$api.post('/api/asset/read-ledgers', {
        AssetId: this.forms.AssetId,
        File: file.data,
      })
      this.rebindPotensi++
    },
    Save() {
      this.$emit('save', this.forms)
    },
    rowClick(row) {
      let x = row.Lokasi.replace(/[^\d.-\s]/g, '').split(' ')

      // let icon = row.NamaPotensi.match(/SPBU/)
      //   ? 'gas-station'
      //   : row.JenisPenerimaan.match(/usaha/i)
      //   ? 'shopping-bag'
      //   : row.JenisPenerimaan.match(/reklame/i)
      //   ? 'label'
      //   : 'dot'

      let m = {
        lat: x[0],
        lon: x[1],
        title: row.NamaPotensi,
        layer: 'selected',
        color: 'yellow',
        // iconSrc: `/img/icons/${icon}.png`,
      }
      this.$refs.map.removeLayer('marker-selected')
      this.$refs.map.addMarker(m)
      this.$refs.map.setCenter(m)
    },
    PotensiClick(menu, row) {
      if (menu.text == 'Ubah') {
        this.potensi = {
          ...this.potensi,
          ...row,
          showUpd: false,
        }
        this.potensi.isPotensi = true
        this.potensi.show = true
      } else if (menu.text == 'Penerimaan') {
        this.potensi = {
          ...this.potensi,
          ...row,
          showUpd: false,
        }
        this.potensi.isPotensi = false
        this.potensi.show = true
      } else if (menu.text == 'Hapus') {
        if (confirm(`Hapus ${row.NamaPotensi} ${row.JenisPenerimaan}?`))
          this.$api.call('AST_DelPotensi', {
            PotensiId: row.PotensiId,
          })
      }
    },
    StatusClick(row) {
      if (row.Status == 'Belum Bayar' || row.Status == 'Jatuh Tempo') {
        this.potensi = {
          ...this.potensi,
          ...row,
          show: false,
          showUpd: true,
        }
      }
    },
    AddPotensi() {
      this.potensi = {
        AssetId: this.forms.AssetId,
        isPotensi: true,
        show: true,
        showUpd: false,
      }
    },
    OpenStreetView(row) {
      if (row.Lokasi) {
        let [lat, lon] = row.Lokasi.replace(/[A-Z()]/g, '').split(' ')
        window.open(
          `http://maps.google.com/?cbll=${lat},${lon}&cbp=12,20.09,,0,5&layer=c`,
          '_blank'
        )
      }
    },
  },
}
</script>
